import full_name from '@/helpers/full_name'

export default {
  install(Vue, opts = {}) {
    Vue.prototype.$getText = (model, morph) => {
      switch (model) {
        case 'App\\Models\\Company':
          return morph.name
          break
        case 'App\\Models\\Employer':
          return full_name.by(morph, undefined, true)
          break
        case 'App\\Models\\EmployerShortPhone':
          return full_name.by(morph, undefined, true, true, false)
          break
        case 'App\\Models\\User':
          return full_name.by(morph, undefined, true, true, true)
          break
        case 'App\\Models\\UserShortPhone':
          return full_name.by(morph, undefined, true, true, false)
          break
        case 'App\\Models\\UserPhonePrefixPostfix':
          return full_name.by(morph, undefined, false, false, true, true)
          break
        case 'App\\Models\\Unit':
          return morph.name
          break
        case 'App\\Models\\Store':
          return morph.title
          break
        case 'App\\Models\\CashRegister':
          return morph.title
          break
        case 'App\\Models\\Booking':
          return `Заявка #${morph.id}`
          break
        case 'App\\Models\\Contractor':
          return `${morph.name_full} ${morph.itn}`
          break
        case 'App\\Models\\BankAccount':
          return `${morph.bank_name} ${morph.bank_code}`
          break
        case 'App\\Models\\BankAccount':
          return morph.bank_name
          break
        default:
          if (morph && morph.title) return morph.title
          return ''
      }
    }
  },
}
